import { CloudUpload } from '@mui/icons-material';
import { Button } from '@mui/material';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { useUploadDispatch } from '~/contexts/upload';

export interface UploadButtonProps extends ComponentProps<typeof Button> {
  folderId: number;
}

export const UploadButton = ({ folderId, ...props }: UploadButtonProps) => {
  const { t } = useTranslation();
  const uploadDispatch = useUploadDispatch();

  return (
    <span>
      <Button
        color="primary"
        onClick={(event) => {
          uploadDispatch({
            type: 'setDialogOpen',
            dialogOpen: true,
            folderId,
            returnFocus: event.currentTarget,
          });
        }}
        startIcon={<CloudUpload />}
        variant="contained"
        {...props}
      >
        {t('common.buttons.upload')}
      </Button>
    </span>
  );
};
